// extracted by mini-css-extract-plugin
export default {"admin":"styles_admin__OO0N+"};